export default {
    mounted(el) {
        strip(el)
    },
    updated(el) {
        strip(el)
    }
}

function strip(root) {
    root
        .querySelectorAll('.vue-slider-dot')
        .forEach(dot => {
            dot.removeAttribute('tabindex')
            dot.removeAttribute('role')
            dot.removeAttribute('aria-valuetext')
            dot.removeAttribute('aria-valuenow')
            dot.removeAttribute('aria-valuemin')
            dot.removeAttribute('aria-valuemax')
            dot.removeAttribute('aria-orientation')
        })
}
